import { useState } from "react";
import axios from "axios";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { ClipboardList } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const d = (v) => (v && v.length >= 10 && v[4] === "-" ? `${v.slice(8, 10)}.${v.slice(5, 7)}.${v.slice(0, 4)}` : v || "—");
const Badge = ({ ok, children }) => (
  <span className={`text-xs px-2 py-0.5 rounded ${ok ? "bg-emerald-100 text-emerald-700" : "bg-red-100 text-red-700"}`}>{children}</span>
);

export const PraktikumNachweise = () => {
  const [data, setData] = useState(null);
  const laden = async () => setData((await axios.get(`${API}/praktikum-nachweise`)).data);
  const bestaetigung = async (t) => {
    const betrieb = window.prompt("Praktikumsbetrieb", t.einrichtung || "");
    if (betrieb === null) return;
    const adresse = window.prompt("Adresse des Betriebs (optional)", "") ?? "";
    const von = window.prompt("Praktikum von (TT.MM.JJJJ)", "") ?? "";
    const bis = window.prompt("Praktikum bis (TT.MM.JJJJ)", "") ?? "";
    const r = await axios.get(`${API}/teilnehmer/${t.teilnehmer_id}/praktikumsbestaetigung-pdf`, { params: { betrieb, adresse, von, bis, stunden: "40" }, responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a"); a.href = url; a.download = `Praktikumsbestaetigung_${t.name.replace(/\W/g, "_")}.pdf`; a.click(); URL.revokeObjectURL(url);
  };

  return (
    <Card className="card-custom mb-6" data-testid="praktikum-nachweise-card">
      <CardHeader className="pb-2 flex flex-row items-center justify-between">
        <CardTitle className="text-base flex items-center gap-2"><ClipboardList size={18} /> Praktikumsnachweise · MN 364 1232 2024 (Pflegehilfskraft)</CardTitle>
        <Button size="sm" variant="outline" onClick={laden} data-testid="praktikum-nachweise-laden">{data ? "Aktualisieren" : "Liste laden"}</Button>
      </CardHeader>
      {data && (
        <CardContent className="pt-0 overflow-x-auto">
          <table className="w-full text-sm" data-testid="praktikum-nachweise-tabelle">
            <thead><tr className="text-left text-stone-500 border-b"><th className="py-1">Teilnehmende</th><th>Kurs</th><th>Zeitraum</th><th>Einrichtung</th><th>Vertrag</th><th>Laufzettel</th><th>Nachweis</th><th></th></tr></thead>
            <tbody>
              {data.teilnehmer.map((t) => (
                <tr key={t.teilnehmer_id} className="border-b last:border-0" data-testid={`praktikum-row-${t.teilnehmer_id}`}>
                  <td className="py-1 font-medium">{t.name}</td>
                  <td>{t.kurs || "—"}</td>
                  <td className="whitespace-nowrap">{d(t.start)} – {d(t.ende)}</td>
                  <td>{t.einrichtung || "—"}</td>
                  <td><Badge ok={t.vertrag.length > 0}>{t.vertrag.length ? "vorhanden" : "fehlt"}</Badge></td>
                  <td title={t.laufzettel.join(", ")}><Badge ok={t.laufzettel.length > 0}>{t.laufzettel.length ? "vorhanden" : "fehlt"}</Badge></td>
                  <td><Badge ok={t.nachweis_erbracht}>{t.nachweis_erbracht ? "erbracht" : "offen"}</Badge></td>
                  <td><Button size="sm" variant="ghost" onClick={() => bestaetigung(t)} data-testid={`praktikum-bestaetigung-${t.teilnehmer_id}`}>Bestätigung (PDF)</Button></td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="text-xs text-stone-500 mt-2">{data.anzahl} Teilnehmende · Laufzettel = hochgeladene Datei mit „Laufzettel“, „Praxisnachweis“ oder „Praktikumsbewertung“ im Namen</p>
        </CardContent>
      )}
    </Card>
  );
};
